import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { InputText } from 'primereact/inputtext'
import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../reducers'
import { useDispatch } from 'react-redux'
import useEffectOnce from '../hooks/useEffectOnce';
import { DeleteAssistant, editAssistants, fetchAssistantList, verifyAdd } from '../reduxactions/suprivisoractions/SupAssActions';
import { SUPRIVISOR_API } from '../ApiNames'
import { LoginService } from '../services/LoginService'
import { Dialog } from 'primereact/dialog'
import { useNavigate } from 'react-router-dom'
import { Toast } from 'primereact/toast'

export const SuprivisorAssistantlist = () => {
  const uid = window.sessionStorage.getItem('uid');
  const usertype = window.sessionStorage.getItem('usertype');

  const [globalFilter, setGlobalFilter] = useState('');

  const data = useSelector((state: RootState) => state.sasslist.data);




  const dispatch = useDispatch();


  //To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchAssistantList(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffectOnce(() => {
    fetchDataAsync();
  }, [dispatch]);
  const [DoctorID, setDoctorID] = useState('');
  const [FirstName, setFirstname] = useState('')
  const [LastName, setLastname] = useState('')
  const [Email, setEmail] = useState('')
  const [Phone, setPhone] = useState('')
  const [Address, setAddress] = useState('')
  const [addDilog, setaddDilog] = useState(false);
  const toast = useRef<Toast>(null);

  const addDataAsync = async () => {
    try {
      const payload = { fname: FirstName, lname: LastName, email: Email, phone: Phone, address: Address, uid: uid, q: 2 };
      const apiname = SUPRIVISOR_API.addassistant;
      const response = await LoginService.getData(apiname, payload);
      if (response === "Added Successfully") {
        if (toast.current) {
          toast.current.show({ severity: 'success', detail: response });
        }
      } else {
        if (toast.current) {
          toast.current.show({ severity: 'info', detail: response });
        }
      }
      fetchDataAsync();
      setaddDilog(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const close = () => {
    setaddDilog(false);
    setDoctoredit(false);
    setDeleteConfirmation(false);
  };
  const [doctoredit, setDoctoredit] = useState(false);
  const [editData, setEditData] = useState({
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Address: '',
    AssistantID: '',
  });

  const Editdata = (rowData: any) => {
    setEditData({
      FirstName: rowData.FirstName,
      LastName: rowData.LastName,
      Email: rowData.Email,
      Phone: rowData.Phone,
      Address: rowData.Address,
      AssistantID: rowData.AssistantID,
    });
    setDoctoredit(true);
  }

  const toast1 = useRef<Toast>(null);

  const EditcontestRules = async () => {
    const { FirstName, LastName, Email, Phone, Address, AssistantID } = editData;
    try {
      const response = await dispatch(editAssistants(FirstName, LastName, Email, Phone, Address, AssistantID) as any);
      if (toast1.current) {
        toast1.current.show({ severity: 'success', detail: response, summary: 'Updated Successfully' });
      }
      setDoctoredit(false);
      fetchDataAsync();
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const verify = useSelector((state: RootState) => state.sasslist.verify);


  const getAddressData = async () => {
    const { Address, AssistantID } = editData;
    try {
      const payload = { address: Address, aid: AssistantID, q: 1 };
      const apiname = SUPRIVISOR_API.verifyadd;
      const data = await LoginService.getData(apiname, payload);
      if (data) {
        setAddress(data);
        //toast.current.show({ severity: 'success', summary: 'Verified Successfully', details: verify, life: 3000 });
      } else {
        console.warn('Invalid or empty response:', data);
      }
      fetchDataAsync();
    } catch (error) {
      console.error('Error fetching address data:', error);
    }
  };
  //Delete code
  const removedata = useSelector((state: RootState) => state.sasslist.remove);
  // const toast4 = useRef(removedata);
  const [delData, setDeleteData] = useState({
    AssistantID: '',
  });

  const [deleteConfirmation, setDeleteConfirmation] = useState(false);

  const Delete = (rowData: any) => {

    setDeleteData({
      AssistantID: rowData.AssistantID,
    });
    setDeleteConfirmation(true);
  };
  const toast2 = useRef<Toast>(null);

  const confirmDelete = async () => {
    const { AssistantID } = delData;
    try {
      const data = await dispatch(DeleteAssistant(AssistantID) as any);
      if (toast2.current) {
        toast2.current.show({ severity: 'error', detail: data, summary: 'Deleted Successfully' });
      }
      setDeleteConfirmation(false);
      fetchDataAsync();
    } catch (error) {
      console.error('Error deleting data:', error);
    }
  };
  const navigate = useNavigate();
  const viewPage = (rowData: any) => {
    const url = `/viewassistantdetails/${rowData.AssistantID}`;
    console.log('rowdata:', rowData.AssistantID)
    navigate(url);
  }
//for help
 const [openHelp, setHelp] = useState(false);
 const url1 = window.sessionStorage.getItem("apiRoot");
 const IUrl = `${url1}/help/sup-assistent.php`;
 const helpImg = `${url1}/help/help3.png`;
 const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
   event.preventDefault();
   const newWindowReference = window.open(
     targetUrl,
     'newwindow',
     'width=1000,height=1000,noopener,noreferrer'
   );
 
   if (newWindowReference) {
       newWindowReference.opener = null;
   }
 };

  return (
    <div style={{ marginLeft: '220px' }}>
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="grid mb-2">
              <div className="col-6">
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="card-header p-2" style={{ marginTop: '50px' }}>
                <h2>Assistants List</h2>
              </div>
              <div className="col-16" style={{ textAlign:"right"}}>
                    <a
                      title="help"
                      onClick={(e) => openWindow(e, IUrl)}
                      style={{

                        color: "blue",
                        fontSize: 15, cursor: "pointer"
                      }}
                    >Help for this Page &nbsp;
                      <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                    </a>
                  </div>
              <br></br>
              <div className="card flex flex-wrap justify-content-end">
                <Button label="Add Assistants" severity="info" onClick={() => setaddDilog(true)} style={{ marginRight: '50px' }} />

              </div>
              <div className="box box-primary">
                <div className="card">
                  <p className="m-0">
                    <div>
                      <div className="card flex flex-wrap justify-content">
                        <span className="p-input-icon-left">
                          <i className="pi pi-search" style={{ paddingLeft: '5px' }} />
                          <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" style={{ paddingLeft: '25px' }} />
                        </span>

                      </div>
                      <DataTable value={data} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                        globalFilterFields={['FirstName', 'LastName', 'Email', 'status']}>
                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>

                        <Column body={(rowData) => `${rowData.FirstName} ${rowData.LastName}`} sortable header="Assistant Name"></Column>
                        <Column field="Email" sortable header="Email "></Column>
                        <Column field="status" sortable header="Status" body={(rowData) => rowData.status.charAt(0).toUpperCase() + rowData.status.slice(1).toLowerCase()} />

                        <Column header="Option" body={(rowData) => (

                          <div className="options-buttons" style={{ marginLeft: '-30px' }}>
                            <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-3" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => viewPage(rowData)} />
                            <Button rounded outlined className='mr-3' tooltip="Edit" icon="pi pi-pencil" style={{ backgroundColor: 'white', color: 'seagreen', width: '2rem', height: '2rem' }} onClick={() => Editdata(rowData)} />
                            <Button icon="pi pi-trash" rounded outlined tooltip="Delete" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'red', width: '2rem', height: '2rem' }} onClick={() => Delete(rowData)} />


                          </div>
                        )}></Column>
                      </DataTable>

                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Dialog header="Add Assistant" visible={addDilog} style={{ width: '32vw', height: '63vh' }} onHide={() => setDoctoredit(false)} >
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label">First Name:</label>
          </div>
          <div className="col-6" >
            <InputText id="name" style={{ width: '18vw' }} name="Contest Name" placeholder='Enter FirstName ' onChange={(e) => setFirstname(e.target.value)} />
          </div>
        </div>
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label">Last Name:</label>
          </div>
          <div className="col-6" >
            <InputText id="name" style={{ width: '18vw' }} name="Contest Name" placeholder='Enter FirstName ' onChange={(e) => setLastname(e.target.value)} />
          </div>
        </div>

        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label">Email:</label>
          </div>
          <div className="col-6" >
            <InputText id="amount" style={{ width: '18vw' }} name="amount" placeholder='Enter Email' onChange={(e) => setEmail(e.target.value)} />
          </div>
        </div>

        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label"> Phone:</label>
          </div>
          <div className="col-6" >
            <InputText type="tel" value={Phone} style={{ width: '18vw' }} placeholder='Enter Phone' onChange={(e) => { const value = e.target.value; if (/^\d{0,10}$/.test(value)) { setPhone(value); } }} />
          </div>
        </div>
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label"> Address:</label>
          </div>
          <div className="col-6" >
            <InputText id="amount" style={{ width: '18vw' }} name="amount" placeholder='Enter Address' onChange={(e) => setAddress(e.target.value)} />
          </div>
        </div>
        <Button label="Close" onClick={close} style={{ marginTop: '13px' }} severity="secondary" />
        <Button label="Add" onClick={addDataAsync} style={{ float: 'right', marginTop: '13px' }} />
      </Dialog >
      <Dialog header="Edit Assistant" visible={doctoredit} style={{ width: '35vw', height: '62vh' }} onHide={() => setDoctoredit(false)} >
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label">First Name:</label>
          </div>
          <div className="col-6" >
            <InputText id="name" name="fname" onChange={(e) => setEditData({ ...editData, FirstName: e.target.value })} value={editData.FirstName} style={{ width: '18vw' }} disabled />
          </div>
        </div>
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label">Last Name:</label>
          </div>
          <div className="col-6" >
            <InputText id="name" style={{ width: '18vw' }} name="fname" onChange={(e) => setEditData({ ...editData, LastName: e.target.value })} value={editData.LastName} disabled />
          </div>
        </div>

        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label">Email:</label>
          </div>
          <div className="col-6" >
            <InputText id="name" style={{ width: '18vw' }} name="fname" onChange={(e) => setEditData({ ...editData, Email: e.target.value })} value={editData.Email} disabled />
          </div>
        </div>

        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label"> Phone:</label>
          </div>
          <div className="col-6" >
            <InputText id="name" style={{ width: '18vw' }} name="fname" onChange={(e) => { const value = e.target.value.replace(/\D/g, ''); if (value.length <= 10) { setEditData({ ...editData, Phone: value }); } }} value={editData.Phone} type="number" />
          </div>
        </div>
        <div className="grid pt-1">
          <div className="col-3">
            <label htmlFor="address" className="col-sm-2 control-label"> Address:</label>
          </div>
          <div className="col-6" >
          <InputText id="address" style={{ width: '18vw' }} name="address" onChange={(e) => setEditData({ ...editData, Address: e.target.value })} value={editData.Address} />
            {/* <i className="pi pi-map-marker" onClick={getAddressData} style={{ fontSize: '2em', position: 'absolute', right: '10px', cursor: 'pointer' }}></i> */}
          </div>
        </div>
        <Button label="Close" onClick={close} severity="secondary" style={{ marginTop: '10px' }} />
        <Button label="Update" onClick={EditcontestRules} style={{ float: 'right', marginTop: '10px' }} />
      </Dialog >
      < Dialog header="Confirm Delete" style={{ width: '30vw' }} visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
        <div>Are you really want to Remove...?</div>
        <br></br>
        <Button label="Delete" icon="pi pi-check" className='mr-3 p-button-raised' onClick={confirmDelete} />
        <Button label="Close" icon="pi pi-times" onClick={close} className="mr-3 p-button-secondary" />
      </Dialog >
      <Toast ref={toast} ></Toast>
      <Toast ref={toast1} ></Toast>
      <Toast ref={toast2} ></Toast>

    </div>
  )
}
